import { Cookies } from 'react-cookie';

import { reportSTMonitoringApiResponse, TrapTypeMonitoring } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getSTMonitoring = async (
  slug: string,
  trapType: TrapTypeMonitoring,
  start_date: string,
  end_date: string,
  filter_type: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/${trapType}_monitoring/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_date,
      end_date,
      filter_type,
    },
  });

  return data.data as reportSTMonitoringApiResponse;
};
